import { type FC } from 'react';
import { useIntl } from 'dibs-react-intl';
import { SingleSelect } from 'dibs-elements/exports/SingleSelect.tsx';
import { NftMarketSingleSelectFilter } from './NftMarketSingleSelectFilter.tsx';
import { NftMarketMultiSelectFilter } from './NftMarketMultiSelectFilter.tsx';

import { messages } from './filterConfig.ts';
import {
    type FilterShape,
    type FilterConfig,
    type NftItemSearchAuctionStatus,
    type NftItemSearchAuctionMarketType,
    type NftItemSearchMediumType,
    type NftItemSearchSort,
} from './filterConfig.ts';

import styles from './NftMarketFiltersResponsive.scss';

type Props = {
    state: FilterShape;
    filterConfig: FilterConfig;
    onFiltersChange: (newFilters: FilterShape) => void;
};

export const NftMarketFiltersResponsive: FC<Props> = ({ state, filterConfig, onFiltersChange }) => {
    const { formatMessage } = useIntl();
    return (
        <div className={styles.container}>
            <div className={styles.filterContainer}>
                <div className={styles.selectContainer}>
                    <NftMarketSingleSelectFilter
                        value={state.auctionStatus}
                        options={filterConfig.auctionStatus.options}
                        onChange={selectedOption =>
                            onFiltersChange({
                                ...state,
                                auctionStatus: selectedOption as NftItemSearchAuctionStatus,
                            })
                        }
                        placeholder={formatMessage(messages.availability)}
                        name="Availability filter"
                        dataTn="nft-landing-filter-availability"
                    />
                </div>

                <div className={styles.selectContainer}>
                    <NftMarketSingleSelectFilter
                        value={state.marketType}
                        options={filterConfig.marketType.options}
                        onChange={selectedOption =>
                            onFiltersChange({
                                ...state,
                                marketType: selectedOption as NftItemSearchAuctionMarketType,
                            })
                        }
                        placeholder={formatMessage(messages.market)}
                        name="Market filter"
                        dataTn="nft-landing-filter-market"
                    />
                </div>

                <div className={styles.selectContainer}>
                    <NftMarketMultiSelectFilter
                        values={state.mediumTypes ?? []}
                        options={filterConfig.mediumTypes.options}
                        onChange={selectedOptions =>
                            onFiltersChange({
                                ...state,
                                mediumTypes: selectedOptions as NftItemSearchMediumType[],
                            })
                        }
                        placeholder={formatMessage(messages.medium)}
                        name="Medium filter"
                        dataTn="nft-landing-filter-medium"
                    />
                </div>
            </div>

            <div className={styles.sortContainer}>
                <div className={styles.sortContainer}>
                    <SingleSelect
                        value={state.sortBy ?? ''}
                        onChange={selection =>
                            onFiltersChange({
                                ...state,
                                sortBy: selection?.value as NftItemSearchSort,
                            })
                        }
                        options={filterConfig.sortBy.options.map(option => {
                            const label = formatMessage(option.label);
                            return {
                                label,
                                value: option.value ?? '',
                            };
                        })}
                        name="Sort By"
                        dataTn="nft-landing-sort-by"
                        placeholder={formatMessage(messages.sortBy)}
                        dropdownDetachedMode
                        clearable={false}
                        size="medium"
                    />
                </div>
            </div>
        </div>
    );
};
